var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcLinkedin = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.44588 2.8882C0.646443 2.8882 0 2.24068 0 1.44368C0 0.646674 0.647284 0 1.44588 0C2.2428 0 2.89092 0.647514 2.89092 1.44368C2.89092 2.24068 2.2428 2.8882 1.44588 2.8882ZM2.71107 11.999H0.231219V4.02723H2.71107V11.999ZM9.52178 11.9999H12V7.62771C12 5.48109 11.5359 3.82997 9.02497 3.82997C7.81867 3.82997 7.00999 4.49092 6.67878 5.11744H6.64515V4.02817H4.26618V11.9999H6.74435V8.05602C6.74435 7.01631 6.94274 6.00934 8.2331 6.00934C9.50497 6.00934 9.52178 7.19855 9.52178 8.12321V11.9999Z",
    fill: "#B3B3B3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcLinkedin, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-linkedin.59fbfe92.svg";
export { ForwardRef as ReactComponent };